import BenefitButton from './BenefitButton';

export default BenefitButton;
